import { render, staticRenderFns } from "./AccountCancel.vue?vue&type=template&id=619a5764&scoped=true"
import script from "./AccountCancel.vue?vue&type=script&lang=js"
export * from "./AccountCancel.vue?vue&type=script&lang=js"
import style0 from "./AccountCancel.vue?vue&type=style&index=0&id=619a5764&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a5764",
  null
  
)

export default component.exports